import { Loader2 } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

/**
 * App loading state component shown while theme is being loaded
 * Uses neutral colors to avoid theme flash
 */
const AppLoadingState = () => {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        backgroundColor: '#ffffff',
        color: '#374151'
      }}
    >
      <div className="flex flex-col items-center space-y-4">
        <Loader2
          className="w-8 h-8 animate-spin"
          style={{ color: '#6b7280' }}
        />
        <p
          className="text-sm font-medium"
          style={{ color: '#6b7280' }}
        >
          {t('loading')}
        </p>
      </div>
    </div>
  );
};

export default AppLoadingState;